/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ArtigoResponse,
  ArtigosControllerTranscreverBody,
  AssessorControllerListarMinhasParams,
  AtualizarArtigoDto,
  CriarArtigoDto,
  DiscussaoResponse,
  ErroResponse,
  ListaDeArtigosResponse,
  PaginaDeDiscussoesResponse,
  PdfTranscritoResponse,
  ReforcarSaldoDto,
  SaldoAdvisorResponse,
  TransferirDiscussaoDto
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getAssessorControllerListarMinhasUrl = (params?: AssessorControllerListarMinhasParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/assessoria/minhas?${stringifiedParams}` : `/v1/assessoria/minhas`
}

/**
 * @summary Discussões já atribuídas a este advisor
 */
export const assessorControllerListarMinhas = async (params?: AssessorControllerListarMinhasParams, options?: Parameters<typeof httpClient>[1]): Promise<PaginaDeDiscussoesResponse> => {

  return httpClient<PaginaDeDiscussoesResponse>(getAssessorControllerListarMinhasUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAssessorControllerListarMinhasQueryKey = (params?: AssessorControllerListarMinhasParams,) => {
    return [
    `/v1/assessoria/minhas`, ...(params ? [params] : [])
    ] as const;
    }


export const getAssessorControllerListarMinhasQueryOptions = <TData = Awaited<ReturnType<typeof assessorControllerListarMinhas>>, TError = unknown>(params?: AssessorControllerListarMinhasParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assessorControllerListarMinhas>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAssessorControllerListarMinhasQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof assessorControllerListarMinhas>>> = ({ signal }) => assessorControllerListarMinhas(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof assessorControllerListarMinhas>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AssessorControllerListarMinhasQueryResult = NonNullable<Awaited<ReturnType<typeof assessorControllerListarMinhas>>>
export type AssessorControllerListarMinhasQueryError = unknown


export function useAssessorControllerListarMinhas<TData = Awaited<ReturnType<typeof assessorControllerListarMinhas>>, TError = unknown>(
 params: undefined |  AssessorControllerListarMinhasParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof assessorControllerListarMinhas>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof assessorControllerListarMinhas>>,
          TError,
          Awaited<ReturnType<typeof assessorControllerListarMinhas>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAssessorControllerListarMinhas<TData = Awaited<ReturnType<typeof assessorControllerListarMinhas>>, TError = unknown>(
 params?: AssessorControllerListarMinhasParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assessorControllerListarMinhas>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof assessorControllerListarMinhas>>,
          TError,
          Awaited<ReturnType<typeof assessorControllerListarMinhas>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAssessorControllerListarMinhas<TData = Awaited<ReturnType<typeof assessorControllerListarMinhas>>, TError = unknown>(
 params?: AssessorControllerListarMinhasParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assessorControllerListarMinhas>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Discussões já atribuídas a este advisor
 */

export function useAssessorControllerListarMinhas<TData = Awaited<ReturnType<typeof assessorControllerListarMinhas>>, TError = unknown>(
 params?: AssessorControllerListarMinhasParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assessorControllerListarMinhas>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAssessorControllerListarMinhasQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAssessorControllerTransferirUrl = (id: string,) => {




  return `/v1/assessoria/discussoes/${id}/transferir`
}

/**
 * @summary Transfere a discussão para outro advisor
 */
export const assessorControllerTransferir = async (id: string,
    transferirDiscussaoDto: TransferirDiscussaoDto, options?: Parameters<typeof httpClient>[1]): Promise<DiscussaoResponse> => {

  return httpClient<DiscussaoResponse>(getAssessorControllerTransferirUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(transferirDiscussaoDto)
  }
);}





export const getAssessorControllerTransferirMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assessorControllerTransferir>>, TError,{id: string;data: TransferirDiscussaoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof assessorControllerTransferir>>, TError,{id: string;data: TransferirDiscussaoDto}, TContext> => {

const mutationKey = ['assessorControllerTransferir'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assessorControllerTransferir>>, {id: string;data: TransferirDiscussaoDto}> = (props) => {
          const {id,data} = props ?? {};

          return  assessorControllerTransferir(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssessorControllerTransferirMutationResult = NonNullable<Awaited<ReturnType<typeof assessorControllerTransferir>>>
    export type AssessorControllerTransferirMutationBody = TransferirDiscussaoDto
    export type AssessorControllerTransferirMutationError = ErroResponse

    /**
 * @summary Transfere a discussão para outro advisor
 */
export const useAssessorControllerTransferir = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assessorControllerTransferir>>, TError,{id: string;data: TransferirDiscussaoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof assessorControllerTransferir>>,
        TError,
        {id: string;data: TransferirDiscussaoDto},
        TContext
      > => {
      return useMutation(getAssessorControllerTransferirMutationOptions(options), queryClient);
    }
    export const getAssessorControllerObterSaldoUrl = () => {




  return `/v1/assessoria/saldo`
}

/**
 * @summary Saldo de vagas do próprio advisor nesta semana
 */
export const assessorControllerObterSaldo = async ( options?: Parameters<typeof httpClient>[1]): Promise<SaldoAdvisorResponse> => {

  return httpClient<SaldoAdvisorResponse>(getAssessorControllerObterSaldoUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAssessorControllerObterSaldoQueryKey = () => {
    return [
    `/v1/assessoria/saldo`
    ] as const;
    }


export const getAssessorControllerObterSaldoQueryOptions = <TData = Awaited<ReturnType<typeof assessorControllerObterSaldo>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assessorControllerObterSaldo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAssessorControllerObterSaldoQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof assessorControllerObterSaldo>>> = ({ signal }) => assessorControllerObterSaldo({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof assessorControllerObterSaldo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AssessorControllerObterSaldoQueryResult = NonNullable<Awaited<ReturnType<typeof assessorControllerObterSaldo>>>
export type AssessorControllerObterSaldoQueryError = unknown


export function useAssessorControllerObterSaldo<TData = Awaited<ReturnType<typeof assessorControllerObterSaldo>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof assessorControllerObterSaldo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof assessorControllerObterSaldo>>,
          TError,
          Awaited<ReturnType<typeof assessorControllerObterSaldo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAssessorControllerObterSaldo<TData = Awaited<ReturnType<typeof assessorControllerObterSaldo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assessorControllerObterSaldo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof assessorControllerObterSaldo>>,
          TError,
          Awaited<ReturnType<typeof assessorControllerObterSaldo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAssessorControllerObterSaldo<TData = Awaited<ReturnType<typeof assessorControllerObterSaldo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assessorControllerObterSaldo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Saldo de vagas do próprio advisor nesta semana
 */

export function useAssessorControllerObterSaldo<TData = Awaited<ReturnType<typeof assessorControllerObterSaldo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assessorControllerObterSaldo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAssessorControllerObterSaldoQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAssessorControllerReforcarSaldoUrl = () => {




  return `/v1/assessoria/saldo/reforcar`
}

/**
 * @summary Reforça o próprio saldo (1 a 5), até o teto semanal
 */
export const assessorControllerReforcarSaldo = async (reforcarSaldoDto: ReforcarSaldoDto, options?: Parameters<typeof httpClient>[1]): Promise<SaldoAdvisorResponse> => {

  return httpClient<SaldoAdvisorResponse>(getAssessorControllerReforcarSaldoUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(reforcarSaldoDto)
  }
);}





export const getAssessorControllerReforcarSaldoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assessorControllerReforcarSaldo>>, TError,{data: ReforcarSaldoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof assessorControllerReforcarSaldo>>, TError,{data: ReforcarSaldoDto}, TContext> => {

const mutationKey = ['assessorControllerReforcarSaldo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assessorControllerReforcarSaldo>>, {data: ReforcarSaldoDto}> = (props) => {
          const {data} = props ?? {};

          return  assessorControllerReforcarSaldo(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssessorControllerReforcarSaldoMutationResult = NonNullable<Awaited<ReturnType<typeof assessorControllerReforcarSaldo>>>
    export type AssessorControllerReforcarSaldoMutationBody = ReforcarSaldoDto
    export type AssessorControllerReforcarSaldoMutationError = ErroResponse

    /**
 * @summary Reforça o próprio saldo (1 a 5), até o teto semanal
 */
export const useAssessorControllerReforcarSaldo = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assessorControllerReforcarSaldo>>, TError,{data: ReforcarSaldoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof assessorControllerReforcarSaldo>>,
        TError,
        {data: ReforcarSaldoDto},
        TContext
      > => {
      return useMutation(getAssessorControllerReforcarSaldoMutationOptions(options), queryClient);
    }
    export const getArtigosControllerListarUrl = () => {




  return `/v1/assessoria/artigos`
}

/**
 * @summary Lista os artigos do próprio advisor (rascunhos e publicados)
 */
export const artigosControllerListar = async ( options?: Parameters<typeof httpClient>[1]): Promise<ListaDeArtigosResponse> => {

  return httpClient<ListaDeArtigosResponse>(getArtigosControllerListarUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getArtigosControllerListarQueryKey = () => {
    return [
    `/v1/assessoria/artigos`
    ] as const;
    }


export const getArtigosControllerListarQueryOptions = <TData = Awaited<ReturnType<typeof artigosControllerListar>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof artigosControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getArtigosControllerListarQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof artigosControllerListar>>> = ({ signal }) => artigosControllerListar({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof artigosControllerListar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ArtigosControllerListarQueryResult = NonNullable<Awaited<ReturnType<typeof artigosControllerListar>>>
export type ArtigosControllerListarQueryError = unknown


export function useArtigosControllerListar<TData = Awaited<ReturnType<typeof artigosControllerListar>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof artigosControllerListar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof artigosControllerListar>>,
          TError,
          Awaited<ReturnType<typeof artigosControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useArtigosControllerListar<TData = Awaited<ReturnType<typeof artigosControllerListar>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof artigosControllerListar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof artigosControllerListar>>,
          TError,
          Awaited<ReturnType<typeof artigosControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useArtigosControllerListar<TData = Awaited<ReturnType<typeof artigosControllerListar>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof artigosControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os artigos do próprio advisor (rascunhos e publicados)
 */

export function useArtigosControllerListar<TData = Awaited<ReturnType<typeof artigosControllerListar>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof artigosControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getArtigosControllerListarQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getArtigosControllerCriarUrl = () => {




  return `/v1/assessoria/artigos`
}

/**
 * @summary Cria o artigo. Com `arquivoId`, exige `revisado: true`.
 */
export const artigosControllerCriar = async (criarArtigoDto: CriarArtigoDto, options?: Parameters<typeof httpClient>[1]): Promise<ArtigoResponse> => {

  return httpClient<ArtigoResponse>(getArtigosControllerCriarUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(criarArtigoDto)
  }
);}





export const getArtigosControllerCriarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof artigosControllerCriar>>, TError,{data: CriarArtigoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof artigosControllerCriar>>, TError,{data: CriarArtigoDto}, TContext> => {

const mutationKey = ['artigosControllerCriar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof artigosControllerCriar>>, {data: CriarArtigoDto}> = (props) => {
          const {data} = props ?? {};

          return  artigosControllerCriar(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArtigosControllerCriarMutationResult = NonNullable<Awaited<ReturnType<typeof artigosControllerCriar>>>
    export type ArtigosControllerCriarMutationBody = CriarArtigoDto
    export type ArtigosControllerCriarMutationError = unknown

    /**
 * @summary Cria o artigo. Com `arquivoId`, exige `revisado: true`.
 */
export const useArtigosControllerCriar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof artigosControllerCriar>>, TError,{data: CriarArtigoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof artigosControllerCriar>>,
        TError,
        {data: CriarArtigoDto},
        TContext
      > => {
      return useMutation(getArtigosControllerCriarMutationOptions(options), queryClient);
    }
    export const getArtigosControllerTranscreverUrl = () => {




  return `/v1/assessoria/artigos/transcrever`
}

/**
 * @summary Guarda o PDF e devolve o texto transcrito (Markdown) para o advisor revisar. NÃO cria o artigo.
 */
export const artigosControllerTranscrever = async (artigosControllerTranscreverBody: ArtigosControllerTranscreverBody, options?: Parameters<typeof httpClient>[1]): Promise<PdfTranscritoResponse> => {
    const formData = new FormData();
formData.append(`arquivo`, artigosControllerTranscreverBody.arquivo);

  return httpClient<PdfTranscritoResponse>(getArtigosControllerTranscreverUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getArtigosControllerTranscreverMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof artigosControllerTranscrever>>, TError,{data: ArtigosControllerTranscreverBody}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof artigosControllerTranscrever>>, TError,{data: ArtigosControllerTranscreverBody}, TContext> => {

const mutationKey = ['artigosControllerTranscrever'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof artigosControllerTranscrever>>, {data: ArtigosControllerTranscreverBody}> = (props) => {
          const {data} = props ?? {};

          return  artigosControllerTranscrever(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArtigosControllerTranscreverMutationResult = NonNullable<Awaited<ReturnType<typeof artigosControllerTranscrever>>>
    export type ArtigosControllerTranscreverMutationBody = ArtigosControllerTranscreverBody
    export type ArtigosControllerTranscreverMutationError = ErroResponse

    /**
 * @summary Guarda o PDF e devolve o texto transcrito (Markdown) para o advisor revisar. NÃO cria o artigo.
 */
export const useArtigosControllerTranscrever = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof artigosControllerTranscrever>>, TError,{data: ArtigosControllerTranscreverBody}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof artigosControllerTranscrever>>,
        TError,
        {data: ArtigosControllerTranscreverBody},
        TContext
      > => {
      return useMutation(getArtigosControllerTranscreverMutationOptions(options), queryClient);
    }
    export const getArtigosControllerDetalharUrl = (id: string,) => {




  return `/v1/assessoria/artigos/${id}`
}

/**
 * @summary Artigo completo, para editar
 */
export const artigosControllerDetalhar = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<ArtigoResponse> => {

  return httpClient<ArtigoResponse>(getArtigosControllerDetalharUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getArtigosControllerDetalharQueryKey = (id: string,) => {
    return [
    `/v1/assessoria/artigos/${id}`
    ] as const;
    }


export const getArtigosControllerDetalharQueryOptions = <TData = Awaited<ReturnType<typeof artigosControllerDetalhar>>, TError = ErroResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof artigosControllerDetalhar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getArtigosControllerDetalharQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof artigosControllerDetalhar>>> = ({ signal }) => artigosControllerDetalhar(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof artigosControllerDetalhar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ArtigosControllerDetalharQueryResult = NonNullable<Awaited<ReturnType<typeof artigosControllerDetalhar>>>
export type ArtigosControllerDetalharQueryError = ErroResponse


export function useArtigosControllerDetalhar<TData = Awaited<ReturnType<typeof artigosControllerDetalhar>>, TError = ErroResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof artigosControllerDetalhar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof artigosControllerDetalhar>>,
          TError,
          Awaited<ReturnType<typeof artigosControllerDetalhar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useArtigosControllerDetalhar<TData = Awaited<ReturnType<typeof artigosControllerDetalhar>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof artigosControllerDetalhar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof artigosControllerDetalhar>>,
          TError,
          Awaited<ReturnType<typeof artigosControllerDetalhar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useArtigosControllerDetalhar<TData = Awaited<ReturnType<typeof artigosControllerDetalhar>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof artigosControllerDetalhar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Artigo completo, para editar
 */

export function useArtigosControllerDetalhar<TData = Awaited<ReturnType<typeof artigosControllerDetalhar>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof artigosControllerDetalhar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getArtigosControllerDetalharQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getArtigosControllerAtualizarUrl = (id: string,) => {




  return `/v1/assessoria/artigos/${id}`
}

/**
 * @summary Edita o artigo (todos os campos)
 */
export const artigosControllerAtualizar = async (id: string,
    atualizarArtigoDto: AtualizarArtigoDto, options?: Parameters<typeof httpClient>[1]): Promise<ArtigoResponse> => {

  return httpClient<ArtigoResponse>(getArtigosControllerAtualizarUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(atualizarArtigoDto)
  }
);}





export const getArtigosControllerAtualizarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof artigosControllerAtualizar>>, TError,{id: string;data: AtualizarArtigoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof artigosControllerAtualizar>>, TError,{id: string;data: AtualizarArtigoDto}, TContext> => {

const mutationKey = ['artigosControllerAtualizar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof artigosControllerAtualizar>>, {id: string;data: AtualizarArtigoDto}> = (props) => {
          const {id,data} = props ?? {};

          return  artigosControllerAtualizar(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArtigosControllerAtualizarMutationResult = NonNullable<Awaited<ReturnType<typeof artigosControllerAtualizar>>>
    export type ArtigosControllerAtualizarMutationBody = AtualizarArtigoDto
    export type ArtigosControllerAtualizarMutationError = ErroResponse

    /**
 * @summary Edita o artigo (todos os campos)
 */
export const useArtigosControllerAtualizar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof artigosControllerAtualizar>>, TError,{id: string;data: AtualizarArtigoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof artigosControllerAtualizar>>,
        TError,
        {id: string;data: AtualizarArtigoDto},
        TContext
      > => {
      return useMutation(getArtigosControllerAtualizarMutationOptions(options), queryClient);
    }
    export const getArtigosControllerExcluirUrl = (id: string,) => {




  return `/v1/assessoria/artigos/${id}`
}

/**
 * @summary Exclui o artigo e o PDF original
 */
export const artigosControllerExcluir = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getArtigosControllerExcluirUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getArtigosControllerExcluirMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof artigosControllerExcluir>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof artigosControllerExcluir>>, TError,{id: string}, TContext> => {

const mutationKey = ['artigosControllerExcluir'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof artigosControllerExcluir>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  artigosControllerExcluir(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArtigosControllerExcluirMutationResult = NonNullable<Awaited<ReturnType<typeof artigosControllerExcluir>>>

    export type ArtigosControllerExcluirMutationError = ErroResponse

    /**
 * @summary Exclui o artigo e o PDF original
 */
export const useArtigosControllerExcluir = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof artigosControllerExcluir>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof artigosControllerExcluir>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getArtigosControllerExcluirMutationOptions(options), queryClient);
    }
